import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { L10N_LOCALE, L10nTranslatePipe } from 'angular-l10n';
import { MfaFactorsModel, MfaFactorsModelImpl } from './mfa-factors-model';



@Component({
  selector: 'app-mfa-factors',
  imports: [
    MatChipsModule,
    MatIconModule,
    L10nTranslatePipe
  ],
  templateUrl: './mfa-factors.component.html',
  styleUrl: './mfa-factors.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class MfaFactorsComponent {
  public readonly locale = inject(L10N_LOCALE);
  public readonly model = input<MfaFactorsModel>();
  public readonly factors = computed(() => MfaFactorsModelImpl.displayChips(this.model()));
}
